import { instance } from "../../lib/api";
import Constants from "../../utils/CommonConstants";
import { housingNeoSlotsParser, getSellerUuidFromList } from "./housingNeoUtils";

// Action types
export const RESET_HN_FORM_DATA = "RESET_HN_FORM_DATA";
export const SET_HN_FORM_DATA = "SET_HN_FORM_DATA";
export const RESET_HN_PRODUCT_DATA = "RESET_HN_PRODUCT_DATA";
export const SET_HN_LIST = "SET_HN_LIST";
export const PROJECTS_LIST_HN = "PROJECTS_LIST_HN";
export const SET_SLOT_DEDICATED_DATA_HN = "SET_SLOT_DEDICATED_DATA_HN";
export const SET_PROJECT_ID_HN = "SET_PROJECT_ID_HN";
export const SET_SELLERS_LIST_HN = "SET_SELLERS_LIST_HN";
export const SET_FSL_CITIES_HN = "SET_FSL_CITIES_HN";
export const SET_FAS_CITIES_HN = "SET_FAS_CITIES_HN";
export const HN_ALL_CITY_LIST = "ALL_CITY_LIST";
export const HN_HOUSING_LOCALITY = "HN_HOUSING_LOCALITY";
export const RESET_HN_HOUSING_LOCALITY = "RESET_HN_HOUSING_LOCALITY";

// ─── Private helpers (no cross-feature imports) ───────────────────────────────

const mapCityListData = (data) => {
  const { other_cities = [], top_cities = [] } = data;
  const otherCities = other_cities.map((city) => ({
    name: city.name,
    uuid: city.polygon_uuid,
  }));
  const topCities = top_cities.map((city) => ({
    name: city.name,
    uuid: city.polygon_uuid,
  }));
  return [...otherCities, ...topCities];
};

const getImagesFromImageService = (objId, returnPromise) => {
  const url = `/sapna/v1/housing/helper/11?platform=desktop&source_name=WEB&housing_app_name=HousingAds&resource_name=SiteTakeOver-New&attr_name=images&obj_id=${objId}`;
  if (returnPromise) {
    return new Promise((resolve, reject) => {
      instance({ url, method: "GET" })
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  }
  return instance({ url, method: "GET" }).then(({ data: { data = {} } = {} }) =>
    data.map(({ absolute_url: absoluteUrl }) =>
      absoluteUrl.replace("version", "original")
    )
  );
};

const getAllCitiesList = () => {
  const url = `${process.env.DOMAINS.REGIONS}api/v1/polygon/top/cities/list`;
  return new Promise((resolve, reject) => {
    instance({ url, method: "GET" })
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
};

// ─── Exported actions ─────────────────────────────────────────────────────────

export const getAllCities = () => (dispatch) => {
  const url = `${process.env.DOMAINS.REGIONS}api/v1/polygon/top/cities/list`;
  return instance({ url, method: "GET" })
    .then((response) => {
      dispatch({
        type: HN_ALL_CITY_LIST,
        allCities: mapCityListData(response.data),
      });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
    });
};

export const getHousingNeoLocality = (uuid, value) => (dispatch) => {
  if (uuid === Constants.Zunheboto_uuid) {
    uuid = Constants.mumbai_all_uuid;
  }
  const uuidQueryFilter = uuid ? `&polygon_uuid=${uuid}` : "";
  const url = `${process.env.DOMAINS.REGIONS}api/v1/polygon/suggest?service_type=leads&feature_type=locality${uuidQueryFilter}&input=${value}`;
  return instance({ url, method: "GET" })
    .then((response) => {
      dispatch({ type: HN_HOUSING_LOCALITY, payload: response.data });
    })
    .catch((err) => {
      dispatch({
        type: Constants.API_FAIL,
        errMsg: Constants.getErrorMessage(err),
      });
    });
};

export const resetHousingNeoLocality = () => (dispatch) => {
  dispatch({ type: RESET_HN_HOUSING_LOCALITY });
};

export const deleteImage = (sectionData, attrId, tagId) => (dispatch) => {
  const {
    card_id: cardId,
    priority,
    image: { absolute_url: absoluteUrl },
  } = sectionData;
  const cardID = cardId ? cardId.toString() : null;
  getImagesFromImageService(cardId, true)
    .then(({ data = [] }) => {
      let extension = "/cover.jpg";
      let tag_ids = "1282";
      if ([1, 6, 7, 8].includes(priority) || tagId === "1445") {
        extension = "/banner.jpg";
        tag_ids = "1445";
      } else if (priority === 9 || priority === 10) {
        extension = "/logo.jpg";
        tag_ids = "1281";
      }
      if (data.length) {
        const imageInfo =
          data.find((image) => {
            const arr = image.absolute_url.split("/");
            return (
              arr
                .slice(0, arr.length - 1)
                .join("/")
                .concat(extension) === absoluteUrl
            );
          }) || {};
        const url = "/sapna/v1/housing/helper/18";
        const apiData = {
          housing_file: {
            attr_id: attrId,
            extension: imageInfo.extension || "jpg",
            authenticity_token: process.env.IMAGE_SERVICE_AUTH_TOKEN,
            priority,
            id: imageInfo.file_id,
            name: imageInfo.name,
            obj_id: cardID,
            tag_ids,
            upload_source: "desktop",
            caption: imageInfo.caption,
          },
        };
        return instance({ url, method: "POST", data: apiData })
          .then((response) => {
            const { data: { data: { message: msg } = {} } = {} } = response;
            dispatch({ type: Constants.SNACKBAR_NOTIFICATION, msg });
          })
          .catch((err) => {
            dispatch({
              type: Constants.API_FAIL,
              errMsg: Constants.getErrorMessage(err),
            });
          });
      }
    })
    .catch((err) => {
      dispatch({
        type: Constants.API_FAIL,
        errMsg: Constants.getErrorMessage(err),
      });
    });
};

export const uploadImageToImageService =
  ({ tagId, tagType }) =>
  (data, sectionData) => {
    const { card_id, priority } = sectionData;
    const cardId = card_id ? card_id.toString() : null;
    const url = "/sapna/v1/housing/helper/10";
    const { attr_id, extension, md5, name } = data;
    let tag_ids = tagId || "1282";
    if ([1, 6, 7, 8].includes(priority)) {
      if (tagType === "stnew") tag_ids = "1545";
      else tag_ids = "1445";
    } else if (priority === 9 || priority === 10) {
      tag_ids = "1281";
    }
    const apiData = {
      upload_source: "web",
      re_upload: "false",
      authenticity_token: process.env.IMAGE_SERVICE_AUTH_TOKEN,
      housing_file: {
        attr_id,
        extension: extension || "jpg",
        md5,
        name,
        is_private: false,
        obj_id: cardId,
        status: "new",
        tag_ids,
      },
    };
    return instance({ url, method: "POST", data: apiData })
      .then(() => getImagesFromImageService(card_id, false))
      .catch(({ response: { data: { errors } = {} } = {} }) => {
        if (errors === "Tags Tags are compulsory") {
          return getImagesFromImageService(card_id, false);
        }
        return Promise.reject(errors);
      });
  };

export const resetFormData = () => (dispatch) =>
  dispatch({ type: RESET_HN_FORM_DATA });

export const setFormData = (section, data, index) => (dispatch) =>
  dispatch({ type: SET_HN_FORM_DATA, payload: { section, data, index } });

export const createHousingNeo =
  (data, updateForm = false) =>
  (dispatch) => {
    const url = `${process.env.DOMAINS.ADVERT}products/create-packages`;
    const editUrl = `${process.env.DOMAINS.ADVERT}products/update-packages?jsession=true`;
    return instance({
      url: updateForm ? editUrl : url,
      withCredentials: true,
      method: "POST",
      data,
    })
      .then((response) => {
        const { data: { data: { message: msg } = {} } = {} } = response;
        dispatch({ type: Constants.SNACKBAR_NOTIFICATION, msg });
      })
      .catch((err) => {
        const errMsg = Constants.getErrorMessage(err);
        dispatch({ type: Constants.API_FAIL, errMsg });
        return Promise.reject(errMsg);
      });
  };

export const getHousingNeoList = (pageNo, totalPages) => (dispatch) => {
  const promise = getProjectIds();
  return promise
    .then((data) => {
      const slotId = data["Neo"] || "";
      dispatch({ type: SET_PROJECT_ID_HN, payload: data });
      const url = `${process.env.DOMAINS.ADVERT}products/get-all-packages?row_per_page=10&current_page_no=${pageNo}&promoted_entity_type_id=2&slot_status_id=0&placeholder_ids=${slotId}`;
      return Promise.all([
        instance({ url, withCredentials: true, method: "GET" }),
        getAllCitiesList(),
      ]).then(([{ data: { data = {} } = {} }, cityData]) => {
        dispatch({
          type: SET_HN_LIST,
          payload: {
            results: housingNeoSlotsParser(data.results, cityData),
            hasNextPage: pageNo === totalPages ? data.next_page_exist : false,
            totalPages,
          },
        });
      });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
      return Promise.reject(errMsg);
    });
};

export const getProjectList = (project) => (dispatch) => {
  const url = `${
    process.env.DOMAINS.SEARCH
  }api/v1/search/suggest?property_category=residential&service=buy&string=${project}&type=project${
    !isNaN(project) ? `&entity_ids[]=${project}` : ""
  }`;
  if (!project) return;
  return instance({ url, method: "GET" })
    .then((response) => {
      dispatch({ type: PROJECTS_LIST_HN, payload: response.data.data.results });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
    });
};

export const getFSLCities = (searchTerm) => (dispatch) => {
  const url = `${process.env.DOMAINS.REGIONS}api/v1/polygon/suggest?super_type=polygon&service_type=buy&input=${searchTerm}`;
  return instance({ url, method: "GET" })
    .then(({ data = [] }) => {
      dispatch({ type: SET_FSL_CITIES_HN, payload: data });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
    });
};

export const getFASCities = (searchTerm) => (dispatch) => {
  const url = `${process.env.DOMAINS.REGIONS}api/v1/polygon/suggest?super_type=polygon&service_type=buy&feature_type=locality,city&input=${searchTerm}`;
  return instance({ url, method: "GET" })
    .then(({ data = [] }) => {
      dispatch({ type: SET_FAS_CITIES_HN, payload: data });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
    });
};

export const getHousingNeoSlotData = (slotId) => (dispatch) => {
  const url = `/sapna/v1/housing/helper/8?slot_id=${slotId}&source=hn_panel`;
  let cities = [];
  let projectMap = {};
  let slotData = {};
  Promise.all([getAllCitiesList(), getProjectIds()])
    .then(([cityData, projectMapData]) => {
      cities = cityData;
      projectMap = projectMapData;
      return instance({ url, method: "GET" })
        .then(({ data: { data = {} } = {} }) => {
          slotData = data;
          const { promoted_entity = {} } = slotData;
          const { entity_id: projectId = "" } = promoted_entity;
          return dispatch(getProjectsData(projectId));
        })
        .then((projectArr = []) => {
          const { name = "" } = projectArr[0] || [];
          dispatch({
            type: SET_SLOT_DEDICATED_DATA_HN,
            payload: housingNeoSlotsParser(slotData, cities, projectMap, name),
          });
        })
        .catch((error) => {
          const errMsg = Constants.getErrorMessage(error);
          dispatch({ type: Constants.API_FAIL, errMsg });
        });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
    });
};

export const getProjectIds = () => {
  const url = `${process.env.DOMAINS.AP}products-mapping`;
  return new Promise((resolve, reject) => {
    instance({ url, method: "GET" })
      .then(({ data }) => resolve(data))
      .catch((error) => reject(error));
  });
};

export const getSellerUUID = (projectId) => (dispatch) => {
  dispatch({
    type: SET_SELLERS_LIST_HN,
    payload: { sellerList: [], projectRegion: [] },
  });
  const sliceKeys = encodeURIComponent(
    JSON.stringify([
      { developer_information: ["profile_uuid", "name"] },
      "polygons_hash",
    ])
  );
  const url = `${process.env.DOMAINS.VENUS}api/v7/new-projects/${projectId}/webapp?version=v3&slice_keys=${sliceKeys}`;
  return instance({ url, method: "GET" })
    .then((response) => {
      const sellersInfo = response?.data?.data?.developer_information ?? [];
      const profileUuids = sellersInfo
        .map((seller) => seller.profile_uuid)
        .filter((uuid) => uuid)
        .join(",");

      const helperSliceKeys = encodeURIComponent(JSON.stringify(["details"]));
      const helperPromise = profileUuids
        ? instance({
            url: `sapna/v1/housing/helper/35?profile_uuids=${profileUuids}&slice_keys=${helperSliceKeys}`,
            method: "GET",
          })
        : Promise.resolve({});

      const locality = response?.data?.data?.polygons_hash?.locality ?? null;
      const projectRegion = locality ? [{ ...locality }] : [];

      const dispatchSellerList = (finalSellerList) => {
        dispatch({
          type: SET_SELLERS_LIST_HN,
          payload: { sellerList: finalSellerList, projectRegion },
        });
      };

      return helperPromise
        .then((helperResponse) => {
          const sellerDetails = helperResponse?.data?.data?.details || {};
          dispatchSellerList(getSellerUuidFromList(sellersInfo, sellerDetails));
        })
        .catch(() => {
          dispatchSellerList(getSellerUuidFromList(sellersInfo));
        });
    })
    .catch((error) => {
      const errMsg = Constants.getErrorMessage(error);
      dispatch({ type: Constants.API_FAIL, errMsg });
    });
};

export const getProjectIdData = () => (dispatch) => {
  getProjectIds()
    .then((data) => {
      dispatch({ type: SET_PROJECT_ID_HN, payload: data });
    })
    .catch((error) => {
      const { data: { apiErrors: { details = "", displayPhrase = "" } = {} } = {} } =
        error || {};
      dispatch({ type: Constants.API_FAIL, errMsg: details || displayPhrase });
    });
};

export const getProjectsData =
  (projectIds = "") =>
  (dispatch) => {
    const url = `${process.env.DOMAINS.VENUS}api/v7/new-projects/bulk-projects-data?project_ids=${projectIds}`;
    return new instance({ url, method: "GET" })
      .then(({ data: { data = [] } = {} }) => data)
      .catch((error) => {
        const {
          response: {
            data: { apiErrors: { details = "", displayPhrase = "" } = {} } = {},
          } = {},
        } = error || {};
        dispatch({ type: Constants.API_FAIL, errMsg: details || displayPhrase });
        return [];
      });
  };

export const getLocalityData = (localityId = "") => {
  const url = `${process.env.DOMAINS.REGIONS}api/v3/polygon/polygon_info?api_name=GET_POLYGON_INFO&source=web&uuid=${localityId}`;
  return new instance({ url, method: "GET" }).then(
    ({ data: { locality_details: localityInfo = {} } = {} }) => localityInfo
  );
};
